export default "__VITE_ASSET__7e986dfc__"